import { render, staticRenderFns } from "./nutritionRecipes.vue?vue&type=template&id=c146a14a&scoped=true"
import script from "./nutritionRecipes.vue?vue&type=script&lang=js"
export * from "./nutritionRecipes.vue?vue&type=script&lang=js"
import style0 from "./nutritionRecipes.vue?vue&type=style&index=0&id=c146a14a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c146a14a",
  null
  
)

export default component.exports